var map = {
	"./en/admin.php": "./lang/en/admin.php",
	"./en/auth.php": "./lang/en/auth.php",
	"./en/common.php": "./lang/en/common.php",
	"./en/messages.php": "./lang/en/messages.php",
	"./en/pagination.php": "./lang/en/pagination.php",
	"./en/passwords.php": "./lang/en/passwords.php",
	"./en/validation.php": "./lang/en/validation.php",
	"./vendor/laravel-backup/en/notifications.php": "./lang/vendor/laravel-backup/en/notifications.php"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./lang sync recursive ^\\.\\/.*\\.php$";